module.exports = __webpack_public_path__ + "img/1alB-t-tap.daae0cca.jpg";